import icons from '../../../../icons';
import { targetStateEditModal } from './targetStateEditModal';


/**
 * returns a button the represents a target transition state.
 * @param {Object} params
 * @param {Object} params.targetState the current target transition state
 * @param {Array} params.states a list of fsm states
 * @param {() =>  void} params.onDeleteTargetState callback to delete the target transition state
 * @param {() => void} params.onEditTargetStateDone callback to edit the target transition state.
 * @param {Object} params.library the library object
 * @returns {JQuery<HTMLElement>}
 */
export const targetStateButton = ({
  targetState,
  states,
  onDeleteTargetState,
  onEditTargetStateDone,
  library
}) => {

  const lNextStateContainer = $('<div>').addClass('ml_fsm_target_state');
  const lOpenNextStateEditModalButton = $('<div>')
    .text(targetState.stateName)
    .addClass('ml_fsm_target_state_name')
    .on('click', () => {
      targetStateEditModal({
        targetState: targetState,
        states: states,
        library,
        onEditTargetStateDone
      });
    });

  const lDeleteNextStateButton = $('<div>')
    .addClass('ml_fsm_target_state_deleter')
    .append($('<i>').addClass(icons.close))
    .on('click', onDeleteTargetState);


  return lNextStateContainer.append(
    lOpenNextStateEditModalButton,
    lDeleteNextStateButton
  );
};
